import { render, staticRenderFns } from "./BussinessAccountDetail.vue?vue&type=template&id=875ff218&scoped=true"
import script from "./BussinessAccountDetail.vue?vue&type=script&lang=js"
export * from "./BussinessAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./BussinessAccountDetail.vue?vue&type=style&index=0&id=875ff218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ff218",
  null
  
)

export default component.exports